import { memo } from "react";
import AgenciesTable from "./AgenciesTable";

import { CompanyType } from "$types/CompanyType";

import { AgenciesBottomBlock } from "./AgenciesBottomBlock";

export const ResumeCarrier = memo(function ResumeCarrier({
  company,
  fetchCompany,
  selectedTab,
  redirect,
  control, // TODO patch à retirer
}: any) {
  const isCarrier = company?.companyTypes
    ?.filter((t) => t === selectedTab)
    .includes(CompanyType.CARRIER);

  const isAgency = company?.companyTypes
    ?.filter((t) => t === selectedTab)
    .includes(CompanyType.AGENCY);

  return (
    <>
      {isCarrier && (
        <AgenciesTable
          company={company}
          redirect={redirect}
          fetchCompany={fetchCompany}
          selectedTab={selectedTab}
        />
      )}

      {/* Agency bottom blocks */}
      {isAgency && (
        <AgenciesBottomBlock
          control={control}
          company={company}
          fetchCompany={fetchCompany}
        />
      )}
    </>
  );
});
